<template>
  <div v-if="isSupported">
    <!-- the wrapper takes the parent's space-y margin, which Uno writes with var(): the browser drops var() values
         on <geolocation> -->
    <geolocation
      class="text-stone-100/100 text-4 px-2 py-1 rounded border-none shadow-md shadow-stone-200 bg-stone-500/100 hover:(bg-stone-600/100 shadow-stone-300) active:(bg-stone-700/100 shadow-stone-400)"
      accuracymode="precise"
      @location="onLocation"
    ></geolocation>
  </div>
</template>
<script setup>
// <geolocation> (Chrome 144+) is a "Use precise location" button drawn by the browser. When location access is
// blocked, clicking it offers to allow it again, which a script can't do. Elsewhere this renders nothing.
//
// It is styled like Button's stone theme, adjusted for the browser's rules for this element:
// - one shade darker, since it is disabled below 3:1 text contrast (stone-100 on stone-400 is 2.3:1)
// - colors with an explicit /100: it drops colors that use var(), as Uno's default opacity variable does
// - no hover:opacity-90: it is disabled with any opacity
// - no font-mono: the browser chooses the font
const isSupported = useGeolocationElementSupport();
// "error": the GeolocationPositionError when the user keeps location blocked or it can't be found; the parent
// replaces the button with a message
const emit = defineEmits(["location", "error"]);
const { locationPermissionStatus } = useLocation();

function onLocation(event) {
  const { position, error } = event.target;
  if (position) {
    locationPermissionStatus.value = "allowed";
    announceLocationEnabled(position);
    emit("location", position);
  } else if (error) {
    emit("error", error);
  }
}
</script>
